import React, { Suspense } from 'react';
import { Outlet } from 'react-router';
import { NavHeader } from '../NavHeader';
import { ErrorBoundary } from '../../_components/ErrorBoundary';
import { TimeSpinner } from '../../_components/Loader/TimeSpinner';
import { TroubleDialog } from '../TroubleDialog';
import { useUiContext } from '../Contexts/UIContext/uiCtx';

export const Layout: React.FC = () => {
    const { showNavbar } = useUiContext();

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: '100%',
                gridTemplateRows: showNavbar ? '50px calc(100% - 50px)' : '100%',
                height: '100%',
                width: '100%',
            }}
        >
            <NavHeader />
            <div className="main">
                <ErrorBoundary errorComponent={TroubleDialog}>
                    <Suspense fallback={<TimeSpinner />}>
                        <Outlet />
                    </Suspense>
                </ErrorBoundary>
            </div>
        </div>
    );
};
